import { Navigate, useRoutes, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
// auth
import AuthGuard from '../auth/AuthGuard';
import GuestGuard from '../auth/GuestGuard';
// layouts
import CompactLayout from '../layouts/compact';
import DashboardLayout from '../layouts/dashboard';
// config
import { PATH_AFTER_LOGIN } from '../config-global';
// utils
import { setGlobalNavigate } from '../auth/utils';
//
import {
  LoginPage,
  Page404,
  AppUserManageList,
  ResetPasswordPage,
  AppUserManageAdd,
  UserManageList,
  UserManageAdd,
  Home,
  DeviceModelList,
  DeviceTypeList,
  FeedbackList,
  FeedbackDetail,
  TankManageList,
  AutomationMigrationPage,
} from './elements';
import DeviceManageList from 'src/pages/DeviceManage/list';
import TankTypeList from 'src/pages/TankType/list';
import TankTypeSecondList from 'src/pages/TankType/secondList';
import TankTypeAddSecond from 'src/pages/TankType/addSecondType';
import TankTypeSecondDetail from 'src/pages/TankType/secondDetail';
import OTAManageList from 'src/pages/OTAManage/list';
import OTAManageUpload from 'src/pages/OTAManage/upload';
import OTAManageDetail from 'src/pages/OTAManage/detail';
// ----------------------------------------------------------------------

export default function Router() {
  const navigate = useNavigate();

  // 设置全局导航函数
  useEffect(() => {
    setGlobalNavigate(navigate);
    console.log('✅ 全局导航函数已设置');
  }, [navigate]);

  return useRoutes([
    {
      path: '/',
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        {
          path: 'login',
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          ),
        },
       
      ],
    },
    {
      path: '/dashboard',
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        { path: 'home', element: <Home /> },
        { path: 'resetPassword',element: (<ResetPasswordPage />)},
        {
          path: 'deviceManage',
          children: [
            { element: <Navigate to="/dashboard/deviceManage/list" replace />, index: true },
            { path: 'list', element: <DeviceManageList /> },
            { path: 'deviceModelList', element: <DeviceModelList /> },
            { path: 'deviceTypeList', element: <DeviceTypeList /> },
          ],
        },
        {
          path: 'feedback',
          children: [
            { element: <Navigate to="/dashboard/feedback/list" replace />, index: true },
            { path: 'list', element: <FeedbackList /> },
            { path: 'detail', element: <FeedbackDetail /> },
          ],
        },
        {
          path: 'appUserManage',
          children: [
            { element: <Navigate to="/dashboard/appUserManage/list" replace />, index: true },
            { path: 'list', element: <AppUserManageList/> },
            { path: 'add', element: <AppUserManageAdd/> },
          ],
        },
        {
          path: 'userManage',
          children: [
            { element: <Navigate to="/dashboard/userManage/list" replace />, index: true },
            { path: 'list', element: <UserManageList/> },
            { path: 'add', element: <UserManageAdd/> },
          ],
        },
        {
          path: 'tankType',
          children: [
            { element: <Navigate to="/dashboard/tankType/list" replace />, index: true },
            { path: 'list', element: <TankTypeList/> },
            { path: 'secondList', element: <TankTypeSecondList/> },
            { path: 'addSecond', element: <TankTypeAddSecond/> },
            { path: 'secondDetail', element: <TankTypeSecondDetail/> },
          ],
        },
        {
          path: 'otaManage',
          children: [
            { element: <Navigate to="/dashboard/otaManage/list" replace />, index: true },
            { path: 'list', element: <OTAManageList/> },
            { path: 'upload', element: <OTAManageUpload/> },
            { path: 'detail', element: <OTAManageDetail/> },
          ],
        },
        {
          path: 'tankManage',
          children: [
            { element: <Navigate to="/dashboard/tankManage/list" replace />, index: true },
            { path: 'list', element: <TankManageList/> },
          ],
        },
        {
          path: 'automationMigration',
          children: [
            { element: <Navigate to="/dashboard/automationMigration/list" replace />, index: true },
            { path: 'list', element: <AutomationMigrationPage/> },
          ],
        },
      ],
    },
    {
      element: <CompactLayout />,
      children: [{ path: '404', element: <Page404 /> }],
    },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
